module.exports = __webpack_public_path__ + "ui-static/img/hooks-no-items_dark.c24ce954.svg";